import { useDispatch, useSelector } from 'react-redux';
import { openAuthorizationModal } from '../redux';
import { redirect } from '../utils';
import { selectIsAuthorized, selectDefaultRedirectUrl } from '../selectors/calculator';
import { selectFinancePlatformEnabled } from '../selectors/calculator/selectFinancePlatformEnabled';
import { useSaveOffers } from './useSaveOffers';
import { ETypeAction } from '../types';

interface IUseAuthActionOptions {
  trackingFunction?: () => void;
  redirectUrl?: string;
}

interface IUseAuthActionReturn {
  isLoading: boolean;
  handleAuthAction: () => Promise<void> | void;
}

export const useAuthAction = (options: IUseAuthActionOptions = {}): IUseAuthActionReturn => {
  const { trackingFunction, redirectUrl } = options;
  const dispatch = useDispatch();

  const isAuthorized = useSelector(selectIsAuthorized);
  const defaultRedirectUrl = useSelector(selectDefaultRedirectUrl);
  const financePlatformEnabled = useSelector(selectFinancePlatformEnabled);

  const { isLoading, saveOffers, shouldUseAuthActionV3 } = useSaveOffers({
    redirectUrl,
    defaultRedirectUrl,
  });

  const handleAuthActionV3 = async () => {
    trackingFunction?.();
    if (financePlatformEnabled || isAuthorized) {
      await saveOffers(ETypeAction.REDIRECT_ONLY);

      return;
    }

    await saveOffers(ETypeAction.AUTH_AND_REDIRECT);
  };

  // TODO: Удалить после того как избавимся от ручки v1/getOffers https://jira.cian.tech/browse/CD-236273
  const handleClickOld = () => {
    trackingFunction?.();

    if (financePlatformEnabled || isAuthorized) {
      redirect(defaultRedirectUrl);

      return;
    }

    dispatch(openAuthorizationModal({ redirectUrl: defaultRedirectUrl }));
  };

  const handleAuthAction = shouldUseAuthActionV3 ? handleAuthActionV3 : handleClickOld;

  return { isLoading, handleAuthAction };
};
